import React from 'react';
import { Link } from 'react-router-dom';

function Hyperlink({ children, ...linkProps }) {
  return (
    <Link className="text-indigo-500 hover:text-indigo-800" {...linkProps}>
      {children}
    </Link>
  );
}

export default Hyperlink;
